import { MODULE_NAME as AUDIENCES_MODULE } from 'modules/audiences/config/routes';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isUserPermissionOrFeatureFlagEnabled } from 'modules/taboola-common-frontend-modules/account-configurations/utils/isUserPermissionOrFeatureFlagEnabled';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { columnDefinitions } from './columnDefinitions';
import { CUSTOM_CONTEXTUAL_REPORT_ID } from './customContextualReportId';
import { customColumns, defaultColumns } from './reportPresets';

export const customContextualReportConfig = {
    id: CUSTOM_CONTEXTUAL_REPORT_ID,
    label: 'Topics Segments',
    visibilityCondition: ({ permissions, configs: { selectedAccountConfig } }) =>
        isUserPermissionOrFeatureFlagEnabled(
            permissions,
            selectedAccountConfig,
            REPORT_PERMISSION.ADS_CONSOLE_CUSTOM_CONTEXTUAL,
            FEATURE_FLAGS.ADS_CONSOLE_CUSTOM_CONTEXTUAL_ALLOWED
        ),

    module: AUDIENCES_MODULE,
    endpoint: 'custom-contextual-report',
    rowIdField: FIELDS.ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    isEmptyFooter: true,
    searchPlaceholderMsgId: 'app.reports.custom-contextual.search.placeholder',

    // TODO: DEV-58584 need to convert filter names in the GW. replace sortField + remove sortMap
    // searchField: NAME.field
    searchField: FIELDS.SEGMENT_NAME.field,
    sortMap: {
        [FIELDS.NAME.field]: FIELDS.SEGMENT_NAME.field,
    },
};
